import React, { Component } from "react";

import ItemCard from "../../ListItem/ItemCard";
import no_image_img from "../../../no-image.png";
import ListScroll from "../../ListScroll/ListScroll";

import "./Newest.css";

class Newest extends Component {
    constructor(props) {
        super(props);
        this.no_image = { url: no_image_img };
    }

    indicators() {}

    render() {
        let items = this.props.newest;
        return (
            <div className='NewestComponent'>
                <div className='caption'>
                    <a href='/search?sort="add_time"'>جدید ترین ها</a>
                    <a href='/search?sort="add_time"' className='all'>
                        (مشاهده همه)
                    </a>
                </div>
                <div className='NewestContainer'>
                    <ListScroll items={items} Component={ItemCard} key='id' />
                </div>
            </div>
        );
    }
}

export default Newest;
